import React, { Dispatch, SetStateAction } from 'react';
import { css, useTheme } from '@emotion/react';

import { UpsunTheme } from '@upsun/react-component-library/src/themes';

import { 
  fonts,
  mediaQueries, 
  pxToRem, 
  visuallyHidden 
} from '@upsun/react-component-library/src/styles';

import { inputStylesDark } from '@upsun/react-component-library/src/styles/global-styles-dark';
import { inputStyles } from '@upsun/react-component-library/src/styles/global-styles';

type CurrencySelectorProps = {
  currency: string,
  setCurrency: Dispatch<SetStateAction<string>>
};

const CurrencySelector:React.FC<CurrencySelectorProps> = ({ currency, setCurrency, ...props }) => {
  const theme = useTheme() as UpsunTheme;

  const customStyles = css`
    margin-top: ${pxToRem(8)};
    margin-bottom: ${pxToRem(56)};

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    select {
      ${inputStyles};
      ${theme.name === "dark" && inputStylesDark};
      font-family: ${fonts.primary};
      appearance: none;
      background-image: url("/down.svg");
      background-repeat: no-repeat;
      background-position: calc(100% - 10px);
      padding-right: ${pxToRem(80)};
      min-width: ${pxToRem(100)};
      min-height: ${pxToRem(50)};
      width: max-content;
    }

    ${mediaQueries.md} {
      margin-top: ${pxToRem(16)};
      margin-bottom: ${pxToRem(64)};
    }

    ${mediaQueries.lg} {
      justify-content: flex-end;
    }
  `;

  const selectProps = {
    "data-heap-identifier": "select-currency"
  };

  return (
    <div css={customStyles}>
      <label htmlFor="currency-selector-pricing" css={visuallyHidden}>Select a currency</label>
      <select id="currency-selector-pricing" value={currency} onChange={(e) => setCurrency(e.target.value)} {...selectProps}>
        <option value="GBP">GBP</option>
        <option value="USD">USD</option>
        <option value="CAD">CAD</option>
        <option value="AUD">AUD</option>
        <option value="EUR">EUR</option>
      </select>
    </div>
  );
};

export default CurrencySelector;
